<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Заблокировать'" (onOk)="ok()" >
	<div class="form-group">
		<label>Список сайтов (технических доменов) в один столбец</label>
		<textarea class="form-control" rows="3" [(ngModel)]="domains"></textarea>
		<div style="margin-top: 15px;"><ngb-alert type="danger" *ngIf="alertMessage != ''" (close)="alertMessage = ''">{{alertMessage}}</ngb-alert></div>
	</div>
</base-support-modal>
